/* MY STORE · Favoritos + agregar rápido (todo el sitio).
   - Favoritos: se guardan en el navegador del cliente (sin necesidad de cuenta).
     Corazón en las tarjetas MY STORE, en las tarjetas de colección y en la página de producto,
     ícono con contador en el encabezado y página /pages/favoritos.
   - Agregar rápido: botón "+" / talles sobre la foto; agrega al carrito sin entrar al producto. */
(function () {
  'use strict';
  if (window.__msTienda) return;
  window.__msTienda = true;

  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('ms-tienda-cfg').textContent); } catch (e) {}
  var ROOT = String(cfg.root || '/').replace(/\/?$/, '/');
  var FAV_URL = cfg.favUrl || '/pages/favoritos';
  var KEY = 'msFavs:v1';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.5 8.1 3.5 4.5 7 4.5c2 0 3.4 1.1 5 3 1.6-1.9 3-3 5-3 3.5 0 5.5 3.6 4.3 6.8-1.8 4.6-9.3 9.2-9.3 9.2z"/></svg>';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function dinero(cents) {
    var n = Math.round(Number(cents) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return String(cfg.fmt || 'Gs. {{amount}}').replace(/\{\{\s*[a-z_]+\s*\}\}/, n).replace(/<[^>]*>/g, '');
  }
  function img(u, w) {
    if (!u) return '';
    u = String(u);
    return /[?&]width=\d+/.test(u) ? u.replace(/([?&]width=)\d+/, '$1' + w) : u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
  }

  /* ---------- Aviso flotante ---------- */
  var toastEl, toastT;
  function toast(html) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'ms-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.innerHTML = html;
    toastEl.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  /* ---------- Favoritos ---------- */
  function leer() { try { var a = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function guardar() { try { localStorage.setItem(KEY, JSON.stringify(favs.slice(0, 100))); } catch (e) {} }
  var favs = leer();
  function tiene(h) { for (var i = 0; i < favs.length; i++) if (favs[i].h === h) return true; return false; }

  function pintarBoton(b) {
    var on = tiene(b.dataset.fav);
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    var l = b.querySelector('[data-fav-label]');
    if (l) l.textContent = on ? 'Guardado en favoritos' : 'Guardar en favoritos';
    if (b.classList.contains('ms-fav')) b.setAttribute('aria-label', (on ? 'Quitar ' : 'Guardar ') + (b.dataset.favT || 'prenda') + (on ? ' de favoritos' : ' en favoritos'));
  }
  function contador() { document.querySelectorAll('.ms-fav-head__n').forEach(function (n) { n.textContent = favs.length ? String(favs.length) : ''; }); }
  function pintarTodo() { document.querySelectorAll('[data-fav]').forEach(pintarBoton); contador(); }

  function alternar(b) {
    var h = b.dataset.fav;
    if (!h) return;
    if (tiene(h)) {
      favs = favs.filter(function (f) { return f.h !== h; });
      toast('Quitado de favoritos');
    } else {
      favs.unshift({ h: h, t: b.dataset.favT || '', i: b.dataset.favI || '', p: b.dataset.favP || '', ts: Date.now() });
      toast('♥ Guardado en favoritos · <a href="' + esc(FAV_URL) + '">Ver mis favoritos</a>');
    }
    guardar();
    document.querySelectorAll('[data-fav]').forEach(function (x) { if (x.dataset.fav === h) pintarBoton(x); });
    b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop');
    contador();
    document.dispatchEvent(new CustomEvent('ms-favs:cambio', { detail: { handle: h, guardado: tiene(h) } }));
  }

  window.addEventListener('storage', function (e) { if (e.key === KEY) { favs = leer(); pintarTodo(); } });

  /* Corazón en las tarjetas de colección (las del tema) */
  function handleDe(href) { var m = /\/products\/([^/?#]+)/.exec(href || ''); return m ? decodeURIComponent(m[1]) : ''; }
  function inyectarCorazones() {
    document.querySelectorAll('product-card').forEach(function (card) {
      if (card.__msFav) return;
      var link = card.querySelector('a[href*="/products/"]');
      var h = link && handleDe(link.getAttribute('href'));
      if (!h) return;
      var qa = card.querySelector('quick-add-component');
      var cont = qa ? qa.parentElement : (card.querySelector('.card-gallery') || link.parentElement);
      if (!cont) return;
      card.__msFav = true;
      if (getComputedStyle(cont).position === 'static') cont.style.position = 'relative';
      var foto = cont.querySelector('img');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ms-fav ms-fav--hz';
      b.dataset.fav = h;
      b.dataset.favT = (qa && qa.dataset.productTitle) || (card.querySelector('h3') || {}).textContent || '';
      b.dataset.favI = foto ? (foto.currentSrc || foto.src || '') : '';
      b.innerHTML = HEART;
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); alternar(b); });
      cont.appendChild(b);
      pintarBoton(b);
    });
  }

  /* Ícono con contador en el encabezado */
  function inyectarEncabezado() {
    var acciones = document.querySelector('header-actions');
    if (!acciones || acciones.querySelector('.ms-fav-head')) return;
    var a = document.createElement('a');
    a.className = 'ms-fav-head header-actions__action';
    a.href = FAV_URL;
    a.setAttribute('aria-label', 'Mis favoritos');
    a.innerHTML = HEART + '<span class="ms-fav-head__n" aria-hidden="true"></span>';
    var carrito = acciones.querySelector('button[aria-controls="cart-drawer"], [data-testid="cart-drawer-trigger"]');
    if (carrito) acciones.insertBefore(a, carrito); else acciones.appendChild(a);
    acciones.classList.add('ms-con-fav');
    contador();
  }

  /* ---------- Agregar rápido ---------- */
  function cerrarQA(excepto) {
    document.querySelectorAll('[data-qa].is-open').forEach(function (q) {
      if (q === excepto) return;
      q.classList.remove('is-open');
      var t = (q.closest('[data-qa-scope]') || q).querySelector('[data-qa-toggle]'); if (t) t.setAttribute('aria-expanded', 'false');
    });
  }
  function agregarVariante(id) {
    var actions = window.Shopify && window.Shopify.actions;
    if (actions && actions.updateCart) {
      return actions.updateCart({ lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + id, quantity: 1 }] }, { event: { context: 'standard-action' } })
        .then(function (res) {
          if (res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message);
          return 'drawer';
        });
    }
    return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('x'); return 'ajax'; });
  }
  window.msAgregarVariante = agregarVariante;
  function modoDrawer() { return !!document.querySelector('cart-drawer-component'); }
  function agregar(btn) {
    var id = btn.dataset.qaAdd;
    if (!id || btn.classList.contains('is-loading')) return;
    var txt = btn.textContent;
    btn.classList.add('is-loading');
    agregarVariante(id).then(function (modo) {
      btn.classList.remove('is-loading');
      btn.classList.add('is-ok');
      btn.textContent = '✓';
      var dlg = document.querySelector('#cart-drawer dialog, cart-drawer-component dialog');
      if (!(dlg && dlg.open)) toast('✓ Agregado al carrito · <a href="' + ROOT + 'cart" data-ver-carrito>Ver carrito</a>');
      setTimeout(function () { btn.classList.remove('is-ok'); btn.textContent = txt; cerrarQA(); }, 1300);
    }).catch(function (err) {
      btn.classList.remove('is-loading');
      toast(esc(err && err.message && err.message !== 'x' ? err.message : 'No se pudo agregar. Probá de nuevo.'));
    });
  }

  document.addEventListener('click', function (e) {
    var el;
    if ((el = e.target.closest('[data-ver-carrito]'))) {
      var trig = document.querySelector('[data-testid="cart-drawer-trigger"], button[aria-controls="cart-drawer"]');
      if (trig && modoDrawer()) { e.preventDefault(); toastEl && toastEl.classList.remove('is-on'); trig.click(); }
      return;
    }
    if ((el = e.target.closest('[data-fav]')) && !el.classList.contains('ms-fav--hz')) { e.preventDefault(); alternar(el); return; }
    if ((el = e.target.closest('[data-qa-toggle]'))) {
      e.preventDefault();
      var qa = el.closest('[data-qa]') || (el.closest('[data-qa-scope]') || document).querySelector('[data-qa]');
      if (!qa) return;
      var abrir = !qa.classList.contains('is-open');
      cerrarQA();
      if (abrir) { qa.classList.add('is-open'); el.setAttribute('aria-expanded', 'true'); }
      return;
    }
    if ((el = e.target.closest('[data-qa-add]'))) { e.preventDefault(); if (!el.disabled) agregar(el); return; }
    if (!e.target.closest('[data-qa]')) cerrarQA();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrarQA(); });

  /* ---------- Página de favoritos ---------- */
  function tarjeta(p) {
    var foto = p.featured_image || (p.images && p.images[0]) || '';
    var foto2 = p.images && p.images[1];
    var unico = p.variants.length === 1 && /^default title$/i.test(p.variants[0].title);
    var talles = p.variants.map(function (v) {
      return '<button type="button" class="ms-qa__size" data-qa-add="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + (unico ? '+ Agregar' : esc(v.title)) + '</button>';
    }).join('');
    return '<article class="ms-card ms-favs__item" data-h="' + esc(p.handle) + '">' +
      '<div class="ms-card__top">' +
        '<a class="ms-card__media" href="' + esc(p.url) + '" aria-label="' + esc(p.title) + '">' +
          (foto ? '<img class="ms-card__img" src="' + esc(img(foto, 700)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
          (foto2 ? '<img class="ms-card__img ms-card__img--2" src="' + esc(img(foto2, 700)) + '" alt="" loading="lazy">' : '') +
          '<span class="ms-card__badges">' + (p.available ? '' : '<span class="ms-card__tag">AGOTADO</span>') + '</span>' +
        '</a>' +
        '<button type="button" class="ms-fav" data-fav="' + esc(p.handle) + '" data-fav-t="' + esc(p.title) + '" data-fav-i="' + esc(img(foto, 500)) + '" data-fav-p="' + esc(dinero(p.price)) + '" aria-pressed="true">' + HEART + '</button>' +
        (p.available ? '<div class="ms-qa" data-qa><button type="button" class="ms-qa__plus" data-qa-toggle aria-expanded="false" aria-label="Agregar ' + esc(p.title) + ' al carrito"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 4v12M4 10h12"/></svg></button>' +
          '<div class="ms-qa__panel" data-qa-panel><span class="ms-qa__label">' + (unico ? 'Agregar al carrito' : 'Agregá tu talle') + '</span><div class="ms-qa__sizes">' + talles + '</div></div></div>' : '') +
      '</div>' +
      '<div class="ms-card__info"><a href="' + esc(p.url) + '" class="ms-card__title">' + esc(p.title) + '</a>' +
        '<p class="ms-card__price">' + (p.compare_at_price > p.price ? '<s>' + esc(dinero(p.compare_at_price)) + '</s> ' : '') + esc(dinero(p.price)) + '</p></div>' +
    '</article>';
  }

  function paginaFavoritos() {
    var root = document.querySelector('[data-ms-favs]');
    if (!root || root.__msFavs) return;
    root.__msFavs = true;
    var grid = root.querySelector('[data-favs-grid]');
    var vacio = root.querySelector('[data-favs-vacio]');
    var cuenta = root.querySelector('[data-favs-cuenta]');
    var compartir = root.querySelector('[data-favs-compartir]');
    var productos = {};

    function estado() {
      var n = grid.querySelectorAll('.ms-favs__item').length;
      vacio.hidden = n > 0;
      grid.hidden = n === 0;
      if (cuenta) cuenta.textContent = n ? (n === 1 ? '1 prenda guardada' : n + ' prendas guardadas') : '';
      if (compartir) compartir.hidden = n === 0;
    }
    function cargar() {
      grid.innerHTML = '';
      var lista = favs.slice();
      if (!lista.length) { estado(); return; }
      grid.innerHTML = lista.map(function () { return '<div class="ms-favs__skel"></div>'; }).join('');
      Promise.all(lista.map(function (f) {
        return fetch(ROOT + 'products/' + encodeURIComponent(f.h) + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (res) {
        var html = '';
        res.forEach(function (p) { if (p && p.handle) { productos[p.handle] = p; html += tarjeta(p); } });
        grid.innerHTML = html;
        estado();
      });
    }
    document.addEventListener('ms-favs:cambio', function (e) {
      if (e.detail && !e.detail.guardado) {
        var it = grid.querySelector('.ms-favs__item[data-h="' + (window.CSS && CSS.escape ? CSS.escape(e.detail.handle) : e.detail.handle) + '"]');
        if (it) { it.style.transition = 'opacity .3s ease, transform .3s ease'; it.style.opacity = '0'; it.style.transform = 'scale(.96)'; setTimeout(function () { it.remove(); estado(); }, 300); }
      }
    });
    if (compartir) compartir.addEventListener('click', function () {
      var base = location.origin;
      var txt = 'Mis favoritos de MY STORE:\n' + favs.map(function (f) { var p = productos[f.h]; return '• ' + (p ? p.title : f.t) + ' — ' + base + ROOT + 'products/' + f.h; }).join('\n');
      window.open('https://wa.me/?text=' + encodeURIComponent(txt), '_blank', 'noopener');
    });
    cargar();
  }

  /* ---------- Arranque ---------- */
  function arrancar() {
    inyectarEncabezado();
    inyectarCorazones();
    pintarTodo();
    paginaFavoritos();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
  var pendiente = 0;
  new MutationObserver(function () {
    if (pendiente) return;
    pendiente = requestAnimationFrame(function () { pendiente = 0; inyectarEncabezado(); inyectarCorazones(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('ms-loop:clonado', function () { pintarTodo(); });
  document.addEventListener('shopify:section:load', arrancar);
})();
